import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const AuthHeader = () => {
  const { currentLanguage, changeLanguage, languages } = useLanguage();

  const handleLanguageChange = (event) => {
    changeLanguage(event.target.value);
  };

  return (
    <header className="w-full bg-surface border-b border-border">
      <div className="content-container">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img src="/assets/images/Logo/webp/VAS-LOGO.webp" alt="VA Sprouts Logo" className="h-8 w-auto" />
            <span className="text-xl font-semibold text-text-primary">VA Sprouts</span>
          </div>

          {/* Language Selector */}
          {/* <div className="flex items-center space-x-2">
            <Icon name="Globe" size={18} className="text-text-secondary" />
            <select 
              value={currentLanguage}
              onChange={handleLanguageChange}
              className="text-sm text-text-secondary bg-transparent border-none focus:outline-none cursor-pointer hover:text-text-primary transition-colors"
              aria-label="Select Language"
            >
              {Object.values(languages).map((lang) => (
                <option key={lang.code} value={lang.code}>
                  {lang.nativeName}
                </option>
              ))}
            </select>
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;
